enum CameraErrorType {
  NotAllowedError = 'NotAllowedError',
  NotFoundError = 'NotFoundError',
}

export default CameraErrorType;
